import React from 'react';

import './Nav.scss'

export default class Navbar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: ''
        }
    }

    render() {
        return (
            <div className="nav">
                <nav className="navbar navbar-expand-md navbar-light bg-transparent">
                    <a className="navbar-brand pl-4" href="#">
                        <strong>
                            PORTO
                        </strong>
                    </a>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarCollapse"
                        aria-controls="navbarCollapse"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className="collapse navbar-collapse pr-4" id="navbarCollapse">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item">
                                <a className="nav-link" href="#content">
                                    Portfolio
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        )
    }

}
